import { useEffect } from 'react';

import type { SlotType } from '../ad-slot-config';

type AdSlots = {
  [key: string]: googletag.Slot;
};

// oxlint-disable-next-line typescript/no-explicit-any
declare const YLHH: any;

const adSlots: AdSlots = {};

export const useDefineSlot = ({
  id,
  adUnitPath,
  size,
  refresh,
  isLazyLoaded,
}: SlotType): void => {
  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        window.googletag?.cmd.push(() => {
          googletag.pubads().refresh([adSlots[id]]);
        });
      }, 500);
    }
    // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
  }, [refresh]);

  useEffect(() => {
    if (isLazyLoaded) {
      // @ts-expect-error yieldlove_cmd is defined by header bidding script
      window.yieldlove_cmd?.push(() => {
        YLHH?.utils.lazyLoad(id, () => {
          window.googletag?.cmd.push(() => {
            const slot = googletag.defineSlot(adUnitPath, size, id);

            if (slot) {
              slot.addService(googletag.pubads());
              googletag.display(slot);
              adSlots[id] = slot;
            }
          });

          YLHH?.bidder.startAuction(adUnitPath, undefined);
        });
      });
    } else {
      window.googletag?.cmd.push(() => {
        const slot = googletag.defineSlot(adUnitPath, size, id);

        if (slot) {
          slot.addService(googletag.pubads());
          googletag.display(slot);
          adSlots[id] = slot;
        }
      });
    }

    return () => {
      window.googletag?.cmd.push(() => {
        if (adSlots[id]) {
          googletag.destroySlots([adSlots[id]]);
          delete adSlots[id];
        }
      });
    };
    // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
  }, []);
};
